import { Files } from '../components/Files/Index'
import QueueItem from '../components/QueueItem'
import CaseSummary from '../components/case-summary/CaseSummary'
import CompletedTask from '../components/common/CompletedTask'
import PendingTask from '../components/common/PendingTask'
import UploadScreen from '../components/common/UploadScreen'
import ApproveScreen from '../components/common/approval/ApproveScreen'
import SelectDocumentsScreen from '../components/credit-check/select-documents/SelectDocumentsScreen'
import AssessmentScreenSe from '../components/customer-declaration/AssessmentScreenSe'
import CopyAssessmentScreen from '../components/customer-declaration/CopyAssessmentScreen'
import KycErrorSummary from '../components/customer-declaration/KycErrorSummary'
import Archieve from '../components/document-control/archieve/Archieve'
import AuditScreen from '../components/document-control/audit/AuditScreen'
import PostContolScreen from '../components/document-control/post-control/PostControlScreen'
import SelectPostContolScreen from '../components/document-control/post-control/SelectPostControlScreen'
import { queueDefinition } from '../helpers/queueDefinitionSE'
import { taskMap, tasksFilter } from '../helpers/taskHelper'
import documentGroupBy from '../utils/documentGroupBy'
import userTaskGroupBy from '../utils/userTaskGroupBy'

const { featureToggles = [] } = window.stacc_env
const kycEnabled = featureToggles.includes('kyc-se')
const kycBusinessEnabled = featureToggles.includes('kyc-business-se')

export default {
  case: {
    caseSummary: {
      component: CaseSummary
    },
    tabs: [
      {
        id: 'files',
        title: 'Files',
        component: Files
      }
    ],
    tasks: {
      taskLists: [
        {
          id: 'custom-task-list',
          map: taskMap,
          query:
            'status=completed&status=pending&status=failed&taskCategory=user-task&taskCategory=message-task&taskCategory=service-task&sort=createdAt&dir=-1',
          sort: (taskA: any, taskB: any) => {
            if (taskB.status === 'pending' && taskA.status === 'completed') {
              return 1
            }
            if (taskB.actionTitle === 'Removed') {
              return -1
            }
            if (
              taskA.actionTitle === 'Approve' &&
              taskB.actionTitle !== 'Approve'
            ) {
              return -1
            }

            if (
              taskA.actionTitle === 'Start' &&
              taskB.actionTitle !== 'Start'
            ) {
              return -1
            }

            if (
              taskB.permissions.delete === true &&
              taskA.permissions.delete === false
            ) {
              return 1
            }

            if (
              taskA.variables?.condition?.requiredInternal === true &&
              taskB.variables?.condition?.requiredInternal === true
            ) {
              if (
                taskA.actionTitle === 'Waiting on customer' &&
                taskB.actionTitle !== 'Waiting on customer'
              ) {
                return 1
              }
              return -1
            }

            if (
              taskA.variables?.condition?.requiredInternal === true &&
              taskB.variables?.condition?.requiredInternal === false
            ) {
              return -1
            }

            return new Date(taskA.updatedAt) < new Date(taskB.updatedAt) ? 1 : 0
          },
          groupBy: (task: any) => {
            return (
              userTaskGroupBy[task.taskType] ||
              documentGroupBy[task.context?.conditionType] ||
              'caseworker-task'
            )
          },
          filter: tasksFilter,
          completedTask: CompletedTask,
          pendingTask: PendingTask
        }
      ],
      taskComponents: {
        // Document control
        'approve-signed-document': {
          component: ApproveScreen,
          titleMap: (task: any) => task.context.conditionType
        },
        'dcse-approve-signed-document': {
          component: ApproveScreen,
          titleMap: (task: any) => task.context.conditionType
        },
        'upload-signed-document': {
          component: UploadScreen,
          titleMap: (task: any) => task.context.conditionType
        },
        'dcse-upload-signed-document': {
          component: UploadScreen,
          titleMap: (task: any) => task.context.conditionType
        },
        'select-post-control': {
          component: SelectPostContolScreen
        },
        'dcse-decide-followup-needed': {
          component: SelectPostContolScreen
        },
        'post-control': {
          component: PostContolScreen
        },
        'dcse-follow-up': {
          component: PostContolScreen
        },
        'audit-documents': {
          component: AuditScreen,
          customWidth: '90%',
          customHeight: '90%'
        },
        'dcse-audit-documents': {
          component: AuditScreen,
          customWidth: '90%',
          customHeight: '90%'
        },
        'dcse-assess-customer-declaration': {
          component: AssessmentScreenSe,
          customHeight: '80%'
        },
        // Credit check
        'cc-upload-document': {
          component: UploadScreen,
          titleMap: (task: any) => task.context.conditionType
        },
        'cc-approve-document': {
          component: ApproveScreen,
          titleMap: (task: any) => task.context.conditionType
        },
        'cc-select-document-requirements': {
          component: SelectDocumentsScreen
        },
        'archive-document': {
          component: Archieve
        },
        'dcse-archive-document': {
          component: Archieve
        },
        // customer-declaration-private
        'cdp-se-assessment': {
          component: AssessmentScreenSe,
          customHeight: '80%'
        },
        'cdp-se-provide-information-with-co-applicant': {
          customHeight: '80%'
        },
        'cdp-se-send-answers-to-kyc-api': {
          component: KycErrorSummary,
          customHeight: '80%'
        },
        // customer-declaration-business
        'cdbse-assessment': {
          component: AssessmentScreenSe,
          customHeight: '80%'
        },
        'cdb-assessment-new': {
          component: CopyAssessmentScreen,
          customHeight: '80%'
        }
      }
    },
    businessStatus: {
      map: (flow: any) => {
        if (flow.data && flow.data.businessStatus) {
          return `business-status-${flow.data.businessStatus}`
        }
        return null
      }
    }
  },
  queue: {
    queueItem: QueueItem
  },
  queueDefinition: queueDefinition,
  menu: {
    menuStructure: [
      { name: 'my-cases' },
      {
        name: 'credit-process',
        elems: [
          'Credit Inbox',
          'Ongoing',
          'Approved',
          'Failed credit',
          'credit-unread-chat',
          'credit-not-approved-uploads'
        ]
      },
      {
        name: 'document-control',
        elems: [
          'Incoming',
          'Inbox',
          'Control',
          'Audit',
          'Select post control',
          'Post control',
          'Archiving',
          'Failed',
          'document-control-unread-chat'
        ]
      },
      {
        name: 'payout-se',
        elems: [
          'register-se-hp',
          'perform-payout-se-hp',
          'picked-perform-payout-se-hp',
          'register-se-le',
          'perform-payout-se-le',
          'picked-perform-payout-se-le'
        ]
      },
      {
        name: 'follow-up',
        elems: ['document-control-completed-unread-chat']
      },
      ...(kycEnabled || kycBusinessEnabled
        ? [
            {
              name: 'customer-control-car',
              elems: [
                'cd-assessment-queue-car',
                'cd-assessment-assigned-queue-car',
                'kyc-failed-car'
              ]
            }
          ]
        : []),
      ...(kycEnabled || kycBusinessEnabled
        ? [
            {
              name: 'customer-control-corporate',
              elems: [
                'cd-assessment-queue-corporate',
                'cd-assessment-assigned-queue-corporate',
                'kyc-failed-corporate'
              ]
            }
          ]
        : []),
      ...(kycEnabled || kycBusinessEnabled
        ? [
            {
              name: 'customer-control-equipment',
              elems: [
                'cd-assessment-queue-equipment',
                'cd-assessment-assigned-queue-equipment',
                'kyc-failed-equipment'
              ]
            }
          ]
        : [])
    ]
  }
}
